module.exports = __webpack_public_path__ + "static/media/debit-card.5b11b7a5.svg";